module.exports = __webpack_public_path__ + "img/crate-and-barrel-logo.c88ec794.jpg";